import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import api from "../../../api/api";
import {
  Avatar,
  Badge,
  Button,
  Col,
  DatePicker,
  Flex,
  Input,
  Row,
  Space,
  Table,
  Typography,
  message,
  Select,
} from "antd";
import { IconLeft, IconRight, IconSearch } from "../../../assets/icons";
import { getFormattedNumber } from "@utils";
import _ from "lodash";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import Details from "./Details/Details";
import ConfirmModal from "./ConfirmModal/ConfirmModal";
import {
  GrayTitle,
  TitleWrapper,
  Topbar,
} from "../../Dashboard/BestSellingProducts";
import { UserOutlined } from "@ant-design/icons";
import { useAtom } from "jotai";
import { savedUserTablePage } from "../../../utils/atom";
import moment from "moment";
import { useTranslation } from "react-i18next";

const RootContainer = styled.div`
  .ant-table {
    margin-top: 24px;

    svg {
      cursor: pointer;
    }

    .ant-btn-dangerous {
      width: 200px;
      height: 32px;
      background-color: #ffe6e8;
      font-size: 14px;
      font-weight: 600;
      color: #f00 !important;
      border: none !important;

      :hover {
        background-color: #ffe6e8;
      }
    }

    .ant-btn-ghost {
      width: 200px;
      height: 32px;
      background-color: #e5fce2;
      font-size: 14px;
      font-weight: 600;
      color: #009800 !important;
      border: none !important;

      :hover {
        background-color: #e5fce2;
      }
    }
  }
`;

const Title = styled.div`
  padding-top: 16px;
  padding-bottom: 24px;
  font-size: 24px;
  font-weight: 700;
  color: #1e1e1e;
`;

export const SubTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #1d1014;
  line-height: 1;
`;

const { RangePicker } = DatePicker;

const UserManagement = () => {
  const [savedUserPage,setSavedUserPage] = useAtom(savedUserTablePage);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [totalUsers, setTotalUsers] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
 const [dateFilterType, setDateFilterType] = useState("all");
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(7, "day"),
    dayjs(),
  ]);
  const [pagination, setPagination] = useState({
    current: savedUserPage ?? 1,
    pageSize: 10,
    total: 0,
  });

  const {t} = useTranslation();

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  }, []);

  // Fixed: Use separate effect for initial load and dependency changes
  useEffect(() => {
    getUsers();
  }, [keyword, pagination.current, pagination.pageSize, dateRange,dateFilterType]);

  // const getUsers = (customDateRange = null) => {
  //   setLoading(true);
  //   setData([]);

  //   // Use the provided dateRange or fall back to state
  //   const currentDateRange = customDateRange || dateRange;

  //   // Ensure we have valid dates
  //   if (
  //     !currentDateRange ||
  //     currentDateRange.length !== 2 ||
  //     !currentDateRange[0] ||
  //     !currentDateRange[1]
  //   ) {
  //     console.error("Invalid date range:", currentDateRange);
  //     setLoading(false);
  //     return;
  //   }

  //   const [fromDate, toDate] = currentDateRange;

  //   api
  //     .getUsers({
  //       keyword,
  //       page: pagination.current,
  //       limit: pagination.pageSize,
  //       from: dayjs(fromDate).format("YYYY-MM-DD"),
  //       to: dayjs(toDate).format("YYYY-MM-DD"),
  //     })
  //     .then(({ data, totalUsers }) => {
  //       setLoading(false);
  //       setData(data);
  //       setTotalUsers(totalUsers);
  //       setPagination((prev) => ({
  //         ...prev,
  //         total: totalUsers,
  //       }));
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       message.error(error || "Failed to fetch users");
  //     });
  // };
  const getUsers = () => {
    setLoading(true);
    setData([]);

    let from = "";
    let to = "";

    if (dateFilterType === "date" && dateRange && dateRange.length === 2) {
      from = dayjs(dateRange[0]).format("YYYY-MM-DD");
      to = dayjs(dateRange[1]).format("YYYY-MM-DD");
    }

    api
      .getUsers({
        keyword,
        page: pagination.current,
        limit: pagination.pageSize,
        from,
        to,
      })
      .then(({ data, totalUsers }) => {
        setLoading(false);
        setData(data);
        setTotalUsers(totalUsers);
        setPagination((prev) => ({
          ...prev,
          total: totalUsers,
        }));
      })
      .catch((error) => {
        setLoading(false);
        message.error(error || "Failed to fetch users");
      });
  };


  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      setPagination((prev) => ({ ...prev, current: 1 }));
      setDateRange(dates);
    } else {
      setDateRange(null);
    }
  };

  const debouncedResults = useMemo(() => {
    return _.debounce((e) => {
      setPagination((prev) => ({ ...prev, current: 1 }));
      setKeyword(e.target.value.trim());
    }, 1000);
  }, []);

  const goToDetails = (item) => {
    navigate(`details/${item.id}`);
    setSavedUserPage(pagination?.current)
  };

  const successCallback = () => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === selectedItem.id) {
          return {
            ...item,
            status: !item.status,
          };
        }
        return item;
      })
    );
  };

  const handleItemClicked = (item) => {
    setSelectedItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItem({});
  };

  const statusFilter = [
    { text: t('active'), value: true },
    { text: t('blocked'), value: false },
  ];

  const columns = [
    {
      key: "key",
      title: t('no.'),
      render: (_, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      key: "custom_name",
      dataIndex: "custom_name",
      title: t('customers'),
      width: "28%",
      render: (_, record) => (
        <Space>
         
          <Avatar
            shape="square"
            size={32}
            src={record.social_profile || record.profile_url}
            icon={!record.social_profile && !record.profile_url ? <UserOutlined style={{fontSize:"16px"}} /> : undefined}
          /> 
          <Flex style={{gap:"0px",flexDirection:"column",justifyContent:"start",alignItems:"start"}}>
            <Typography>{record?.custom_name}</Typography>
            <Typography>{record?.username}</Typography>
          </Flex>
        </Space>
      ),
    },
    {
      key: "username",
      dataIndex: "username",
      title: t('join_on'),
      width: "28%",
      render: (_, record) => (
        <Typography>
          {moment(record?.created_at).format("DD MMM YYYY, HH:mm")}
        </Typography>
      )
    },
    {
      key: "status",
      dataIndex: "status",
      title: t('status'),
      filters: statusFilter,
      onFilter: (value, record) => record.status === value,
      render: (_, record) =>
        record.status ? (
          <Badge status="success" text="Active" />
        ) : (
          <Badge status="error" text="Blocked" />
        ),
    },
    {
      key: "actions",
      title: t('actions'),
      render: (_, record) => (
        <Space>
          <IconRight onClick={() => goToDetails(record)} />
        </Space>
      ),
    },
  ];

  const handleTableChange = (newPagination) => {
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    }));
  };

  // const handleDateChange = (dates) => {
  //   console.log("Date picker changed:", dates); // Debug log

  //   if (dates && dates.length === 2) {
  //     // Reset pagination to first page when date changes
  //     setPagination((prev) => ({ ...prev, current: 1 }));
  //     setDateRange(dates);
  //   }
  // };

  const goBack = () => {
    navigate(-1);
  };



  return (
    <RootContainer>
      {location.state === "dashboard" && (
        <Topbar>
          <Button type="default" icon={<IconLeft />} onClick={goBack}>
            {t('back')}
          </Button>
          <TitleWrapper>
            <GrayTitle>{t('dashboard')}</GrayTitle>
            <IconRight />
            <SubTitle>{t('total_customers')}</SubTitle>
          </TitleWrapper>
        </Topbar>
      )}
      <Title>{t('customers')} ({getFormattedNumber(totalUsers)})</Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={10}>
        <Flex style={{gap:"20px"}}>
          <Input
           style={{ width: 500}}
            placeholder={t('search_by_customer_name_id')}
            prefix={<IconSearch />}
            onChange={debouncedResults}
            allowClear
          />
           <Select
              style={{ width: 300}}
              value={dateFilterType}
              onChange={(value) => {
                setDateFilterType(value);
                setDateRange(null);
              }}
              options={[
                { value: "all", label: t('all_time')},
                { value: "date", label: t('date') },
              ]}
            />
            </Flex>
        </Col>
        <Col xs={0} lg={6}></Col>
        <Col xs={24} sm={12} lg={8}>
          {/* <RangePicker
            style={{ width: "100%", height: "48px" }}
            value={dateRange}
            onChange={handleDateChange}
            allowClear={true}
            format="D MMM, YYYY"
          /> */}
           {/* <Space style={{ width: "100%" }} size="middle"> */}
            {/* Select box for filter */}
           
            {/* Show RangePicker only if "Date" is selected */}
            {dateFilterType === "date" && (
              <RangePicker
                style={{ width: "100%", height: "48px" }}
                value={dateRange}
                onChange={handleDateChange}
                allowClear
                format="D MMM, YYYY"
              />
            )}
          {/* </Space> */}
        </Col>
      </Row>
      <Table
        dataSource={data}
        columns={columns}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
        rowKey="id"
      />

      <ConfirmModal
        open={open}
        id={selectedItem.id}
        status={selectedItem.status}
        handleClose={handleClose}
        successCallback={successCallback}
      />
    </RootContainer>
  );
};

const Entry = () => {
  return (
    <Routes>
      <Route path="" element={<UserManagement />} />
      <Route path="/details/:id" element={<Details />} />
    </Routes>
  );
};

export default Entry;
